export default __webpack_public_path__ + "static/media/add.0efe85b2.svg";